import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery } from "../../../../graphql/generated.tsx";
import Loader from "../../../../components/Loader";
import { useNavigate } from "react-router-dom";

const ManageClusters = () => {
  const navigate = useNavigate();
  const [campus, setCampus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { data, loading, error } = useGetAllCampusesQuery();
  const [Isload, setIsload] = useState(true);

  useEffect(() => {
    if (data) setCampus(data.allCampus);
  }, [data]);

  useEffect(() => {
    setTimeout(() => setIsload(false), 2000);
  }, []);

  const filteredCampuses = campus.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading || Isload) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen font-poppins">
          <Loader />
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout>
        <div className="p-6 text-red-600">Error: {error.message}</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />

      <div className="min-h-screen p-6 font-sans md:p-10 bg-white">
        {/* 🔙 Back + 🔍 Search */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 px-4 py-2 transition duration-200 bg-white border border-gray-300 shadow-sm rounded-xl hover:border-blue-500 hover:bg-blue-50"
          >
            <IoMdArrowRoundBack className="w-5 h-5 text-gray-600" />
            <span className="font-medium text-gray-700">Back</span>
          </button>

          <input
            type="text"
            placeholder="Search campuses..."
            className="w-full px-4 py-2 border bg-white/70 rounded-xl md:w-64 focus:ring-2 focus:ring-blue-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Campus Cards Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {filteredCampuses.map((campus) => (
            <div
              key={campus.id}
              onClick={() => navigate(`/admin/clusters/${campus.name}`)}
              className="relative cursor-pointer bg-white rounded-xl border border-gray-200 shadow-md p-5 flex flex-col items-center justify-center min-h-[120px] overflow-hidden transition-all duration-300 hover:bg-gradient-to-br hover:from-white hover:to-blue-50"
            >
              <h5 className="text-xl font-semibold text-center text-gray-800">
                {campus.name}
              </h5>

              <div className="absolute bottom-0 left-0 w-full h-[5px] bg-gradient-to-r from-sky-700 via-sky-400 to-sky-200 rounded-b-xl" />
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredCampuses.length === 0 && (
          <p className="mt-10 text-lg text-center text-gray-500">
            No campuses found.
          </p>
        )}
      </div>
    </AdminLayout>
  );
};

export default ManageClusters;
